/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import report from "./report";
import reservation from "./reservation";
import dashboard from "./dashboard";
// eslint-disable-next-line no-unused-vars
// import appsAndPages from './apps-and-pages'
// import others from './others'
// import chartsAndMaps from './charts-and-maps'
// import uiElements from './ui-elements'
// import formAndTable from './forms-and-table'
import systemManagment from "./system-managment";
import tickets from "./ticket";
import todo from "./todo";
import process from "./process";
import request from "./request";
import vote from "./vote";
import agenda from "@/navigation/vertical/agenda";
import hr from "./hr";
import setting from "./setting";
import meeting from "./meeting";
import oldPanel from "./old-panel";
import aiCamera from "./ai-camera";
import contracts from "./contracts";
// Array of sections
export default [
  // eslint-disable-next-line
  ...dashboard,
  // ...appsAndPages,
  // ...uiElements,
  // ...formAndTable,
  // ...chartsAndMaps,
  // ...others,
  ...tickets,
  ...todo,
  ...process,
  ...request,
  ...meeting,
  ...agenda,
  ...reservation,
  ...systemManagment,
  ...report,
  ...vote,
  ...hr,
  ...setting,
  ...oldPanel,
  ...aiCamera,
  ...contracts,
];
